import request from '@/utils/request' //引入封装好的 axios 请求


//查询行政处罚信息
export function xzcf_list (data = { }) {
  return request({
    url: '/api/v1/xysz/gsdata/xzcf_list',
    method: 'post',
    data: data
  })
}

//查询行政许可信息
export function xzxk_list (data = { }) {
  return request({
    url: '/api/v1/xysz/gsdata/xzxk_list',
    method: 'post',
    data: data
  })
}

//查询守信激励信息
export function sxjl_list (data = { }) {
  return request({
    url: '/api/v1/xysz/gsdata/sxjl_list',
    method: 'post',
    data: data
  })
}


//查询失信惩戒信息
export function sxcj_list (data = { }) {
  return request({
    url: '/api/v1/xysz/gsdata/sxcj_list',
    method: 'post',
    data: data
  })
}

//查询重大税收违法案件当事人信息
export function zdsswf (data = { }) {
  return request({
    url: '/api/v1/xysz/gsdata/zdsswf',
    method: 'post',
    data: data
  })
}


//查询安全生产失信信息
export function aqsc (data = { }) {
  return request({
    url: '/api/v1/xysz/gsdata/aqsc',
    method: 'post',
    data: data
  })
}

//查询严重拖欠工资失信信息
export function tqnmggz (data = { }) {
  return request({
    url: '/api/v1/xysz/gsdata/tqnmggz',
    method: 'post',
    data: data
  })
}



//查询企业
export function compList (data = { }) {
  return request({
    url: '/api/v1/xysz/comp_list',
    method: 'post',
    data: data
  })
}

//企业详情
export function compDetail (data = { }) {
  return request({
    url: '/api/v1/xysz/comp_detail',
    method: 'post',
    data: data
  })
}


//信用评分
export function XYPFDetail (data = { }) {
  return request({
    url: '/api/v1/xysz/XYPF_detail',
    method: 'post',
    data: data
  })
}